import React from 'react';

import Nav from '../Nav/Nav'
import "../../Assets/scss/main.scss"
import './Floor.scss';

function Floor() {
  return (
    <div id="floor" className="Floor">
      <Nav />
    </div>
  );
}

export default Floor;
